import moment from 'moment';

export const nextWeekDate = () => new Date(moment().add(1, 'weeks'));
